module.exports = __webpack_public_path__ + "img/title_head-2.bdc9c117.jpg";